module.exports = __webpack_public_path__ + "img/4040_2.5fadde24.png";